import axios from "axios";

import SignOut from "../components/SignIn/SignOut";
const store = require("store");

const getDPSDetails = async () => {
  const getDPS = `/dps`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3016 + getDPS,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateDesignByRef = async (ref, params) => {
  const updateDesign = `/dps/${ref}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3016 + updateDesign,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const addDeisgnPackageByRef = async (ref, params) => {
  const addDeisgnPackage = `/dps/${ref}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3016 + addDeisgnPackage,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const deleteDesignByRef = async (ref, params) => {
  const delDesign = `/dps/${ref}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "delete",
      url: process.env.REACT_APP_API_URL_3016 + delDesign,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

export {
  addDeisgnPackageByRef,
  getDPSDetails,
  updateDesignByRef,
  deleteDesignByRef,
};
